import { createAction } from "typesafe-actions";

import type { RootState } from "single-spa/store/types";

/**
 * @param stateSliceSelector - function that should return desired state slice
 * @returns - helper typed selector builder function for top level state properties
 */
export const createStatePropertySelector =
    <SLICE extends {}>(stateSliceSelector: (state: RootState) => SLICE) =>
    <PROPERTY extends keyof SLICE>(p: PROPERTY) =>
    (state: RootState) =>
        stateSliceSelector(state)[p];

export const createActionNamespace = (namespace: string) => (actionName: string) => `@@${namespace}/${actionName}`;

export const createNamespacedAction =
    (namespace: string) =>
    <P = undefined>(actionName: string) =>
        createAction(`@@${namespace}/${actionName}`)<P>();
